enum SpellType {
  Direct,
  Periodic,
  Hybrid
}

export default SpellType
